module.exports = __webpack_public_path__ + "media/images/accordion-dcf1cb45737424320e31c2953767cf8a.svg";